import { render, staticRenderFns } from "./WebinarAdmins.vue?vue&type=template&id=0c48f747"
import script from "./WebinarAdmins.vue?vue&type=script&lang=js"
export * from "./WebinarAdmins.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports